// ** Reducers Imports
import navbar from './navbar'
import layout from './layout'
import auth from './authentication'
import todo from '@src/views/apps/todo/store'
import chat from '@src/views/apps/chat/store'
import users from '@src/views/apps/user/store'
import email from '@src/views/apps/email/store'
import invoice from '@src/views/apps/invoice/store'
import calendar from '@src/views/apps/calendar/store'
import ecommerce from '@src/views/apps/ecommerce/store'
import dataTables from '@src/views/tables/data-tables/store'
import permissions from '@src/views/apps/roles-permissions/store'
import closureExecutive from '@src/views/closures/executive/store'
import closureManager from '@src/views/closures/manager/store'
import closureCharge from '@src/views/closures/charge/store'
import closurePayment from '@src/views/closures/payment/store'
import meetings from '@src/views/meetings/store'
import uptakes from '@src/views/uptakes/store'
import prospections from '@src/views/prospections/store'
import equipmentsloan from '@src/views/equipmentsloan/store'
import equipments from '@src/views/equipments/store'
import access from '@src/views/access/store'
import comission from '@src/views/comission/store'
import publication from '@src/views/publication/store'
import attendance from '@src/views/attendance/store'
import loankeys from '@src/views/loankeys/store'
import feepayments from '@src/views/feepayments/store'
import offices from '@src/views/offices/store'
import kpisConfig from '@src/views/kpisconfig/store'
import comissionMaster from '@src/views/comissionMaster/store'
import comissionMasterUni from '@src/views/comissionMasterUni/store'
import unifiedInvoice from '@src/views/unifiedInvoice/store'
import kpisList from '@src/views/kpis/store'
import kpisDetail from '@src/views/kpisdetail/store'
import Dashboardscoc from '@src/views/dashboardscoc/store'
import DashboardsGlobal from '@src/views/dashboardsglobal/store'

const rootReducer = {
  auth,
  todo,
  chat,
  email,
  users,
  navbar,
  layout,
  invoice,
  calendar, 
  ecommerce,
  dataTables,
  permissions,
  closureExecutive,
  closureManager,
  closureCharge,
  closurePayment,
  meetings,
  uptakes,
  prospections,
  equipmentsloan,
  equipments,
  access,
  comission,
  publication,
  attendance,
  loankeys,
  feepayments,
  offices,
  kpisConfig,
  comissionMaster,
  comissionMasterUni,
  unifiedInvoice,
  kpisList,
  kpisDetail,
  Dashboardscoc,
  DashboardsGlobal
}

export default rootReducer
